import PageBuilderSelector from '@v4/utils/selectors/PageBuilderSelector'
import { useCallback } from 'react'
import PageBuilderModel from '@v4/store/builderStore/models/PageBuilder.model'
import PageData from '@v4/utils/data/PageData'
import { ICONS_COMPONENTS } from './SectionAction.const'
import useStyles from './SectionAction.styled'

export const useSectionAction = props => {
	const {
		title,
		withCopy,
		withRemove,
		withToggle,
		sectionId,
		visibility,
		showContent,
		sectionKey,
		dynamicGroup,
	} = props

	const {
		cloneSection,
		setDeletingSectionId,
		toggleVisibilitySection,
		setDynamicContent,
	} = PageBuilderSelector.useActions()

	const isGlobalSection = _.split(sectionKey, '/')[2] === 'theme'

	const classes = useStyles({ ...props, isGlobalSection })

	const activeTierId = PageBuilderSelector.useMetaItemActiveTierId({ sectionId, group: dynamicGroup })
	const pageType = PageBuilderSelector.useType()

	const handleStopPropagation = useCallback(event => {
		event.stopPropagation()
		event.preventDefault()
	}, [])

	const handleDelete = useCallback(() => setDeletingSectionId(sectionId), [sectionId, setDeletingSectionId])

	const handleClone = useCallback(() => cloneSection(sectionId), [cloneSection, sectionId])

	const handleVisibilityClick = useCallback(
		() => toggleVisibilitySection({ id: sectionId, scrolling: PageBuilderModel.SCROLLING_TYPE.SIDEBAR }),
		[sectionId, toggleVisibilitySection],
	)

	const handleDynamicContentChange = useCallback(
		tierId => setDynamicContent({ group: dynamicGroup, sectionId, tierId }),
		[dynamicGroup, sectionId, setDynamicContent],
	)

	return [
		{
			classes,
			title: isGlobalSection ? `Global ${title}` : title,
			withCopy,
			withRemove,
			withToggle,
			VisibilityIcon: ICONS_COMPONENTS[visibility],
			showContent,
			activeTierId: PageData.isTypeResult(pageType) || PageData.isTypeResultPdf(pageType) ? activeTierId : null,
		},
		{ handleDelete, handleClone, handleVisibilityClick, handleStopPropagation, handleDynamicContentChange },
	]
}
